import React from "react";
import Twitter from "../../images/svg/twitter.inline.svg";
import Facebook from "../../images/svg/facebook.inline.svg";
import Instagram from "../../images/svg/instagram.inline.svg";
import * as styles from "./style.module.css";

const SocialNetworkLinks = () => (
  <div className={styles.socialNetworkLinks}>
    <a
      href="https://twitter.com/gainful"
      target="_blank"
      rel="noreferrer"
      aria-label="TWITTER"
      title="TWITTER"
    >
      <span>TWITTER</span>
      <Twitter />
    </a>
    <a
      href="https://www.facebook.com/Gainful/"
      target="blank"
      aria-label="FACEBOOK"
      title="FACEBOOK"
    >
      <span>FACEBOOK</span>
      <Facebook />
    </a>
    <a
      href="https://www.instagram.com/gainful/"
      target="_blank"
      rel="noreferrer"
      aria-label="INSTAGRAM"
      title="INSTAGRAM"
    >
      <span>INSTAGRAM</span>
      <Instagram />
    </a>
  </div>
);

export default SocialNetworkLinks;
